// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".embed-loading-indicator[data-v-ed033380]{background:50%/50px no-repeat url(/wp-content/themes/snappy-theme/assets/images/loading2.gif);width:50px;height:50px;margin:0 auto}", ""]);
// Exports
module.exports = exports;
